// src/pages/FundManagement.jsx
import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import noDataImage from '../assets/no-data.png'; // Replace with your actual asset path

const FundManagement = () => {
  const navigate = useNavigate();

  return (
    <Container className="py-3 text-center">
      <div className="d-flex align-items-center mb-3">
        <Button
          variant="link"
          className="text-dark text-decoration-none px-0 me-2"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left"></i>
        </Button>
        <h5 className="m-0">Fund statement</h5>
      </div>

      <div className="mt-5">
        <img src={noDataImage} alt="No Data" style={{ width: '120px' }} />
        <div className="text-muted mt-2">No Data</div>
      </div>
    </Container>
  );
};

export default FundManagement;
